export enum DomainVerificationStatus {
  Pending = 'Pending',
  Success = 'Verified',
  Failed = 'Unverified',
  TemporaryFailure = 'Temporary Failure',
  NotStarted = 'Not Started',
}
